module.exports = __webpack_public_path__ + "static/media/VirginiaTech_logo_rotated.443875aa.png";